import React from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import { CallMade } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddIcon from '@mui/icons-material/Add';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { useTheme } from '@mui/material/styles';

import collapseDown from '../../../assets/images/icons/chevron-down.svg';
import collapseUp from '../../../assets/images/icons/chevron-up.svg';
import filterOptionIcon from '../../../assets/images/icons/audio-settings-01.svg';

import useCustomNavigate from '../../../hooks/useNavigator';
import { BUTTON_TEXT, REDIRECT_URL, applicationTitle } from '../../../constants';

import './Button.scss';

export const CustomButton = ({
  className,
  variant = 'contained',
  children,
  loading = false,
  isExpanded,
  buttonVariant = 'standard',
  onClick,
  featurePermission = true,
  sx = {},
  typoClass,
  ...props
}) => {
  const theme = useTheme();
  const { goToPage } = useCustomNavigate();

  // handle back to search button
  const handleCancel = () => {
    onClick();
    goToPage(REDIRECT_URL.home);
    document.title = applicationTitle.title; 
  };

  // handle back to search button
  const handleBackToSearch = () => {
    onClick();
  };

  //handle toggle state
  const handleToggleButton = () => {
    onClick(!isExpanded);
  };

  switch (buttonVariant) {
    case 'standard':
      return (
        featurePermission && <Button
          {...props}
          className={className}
          variant={variant}
          sx={{ height: 40, ...sx }}
          onClick={onClick}
        >
          {loading ? (
            <CircularProgress
              size={20}
              sx={{ color: theme.palette.secondary.main }}
            />
          ) : (
            <Typography variant="body1" fontWeight="bold" className = {typoClass ? typoClass : ''}>
              {children}
            </Typography>
          )}
        </Button>
      );
    case 'backToSearch':
      return (
        featurePermission && <Link
          component="button"
          className={`back-to-seach ${className}`}
          underline="none"
          variant="body2"
          sx={{ height: 20, color: theme.palette.secondary[200], ...sx }}
          onClick={handleBackToSearch}
          flex={{ display: 'flex', alignItems: 'center' }}
        >
          <ChevronLeftIcon /> {children ? children : BUTTON_TEXT.backToSearch}
        </Link>
      );
    case 'cancel':
      return (
        featurePermission && <Button
          {...props}
          className={className}
          variant={variant}
          sx={{ height: 40, ...sx }}
          onClick={handleCancel}
        >
          <Typography variant="body1" fontWeight="bold" className = {typoClass ? typoClass : ''}>
            {children}
          </Typography>
        </Button>
      );
    case 'reset':
      return (
        featurePermission && <Button
          {...props}
          className={className}
          variant={variant}
          startIcon={<RefreshIcon />}
          sx={{ height: 40, fontWeight: 'bold', ...sx }}
          onClick={onClick}
        >
     <Typography variant="body1" fontWeight="bold" className = {typoClass ? typoClass : ''}>  {children}</Typography>
        </Button>
      );
    case 'export':
      return (
        featurePermission && <Button
          {...props}
          className={className}
          variant={variant}
          endIcon={<CallMade />}
          sx={{ height: 40, fontWeight: 'bold', ...sx }}
          onClick={onClick}
        >
          {children}
        </Button>
      );
    case 'toggle':
      return (
        featurePermission && <div className="collape-linkwrap">
          <Link
            component="button"
            onClick={handleToggleButton}
            className={isExpanded ? 'collapse-mode' : ''}
          >
            {isExpanded ? (
              <>
                <img src={filterOptionIcon} /> {BUTTON_TEXT.hide}{' '}
                <img src={collapseUp} alt="Show Icon" />
              </>
            ) : (
              <>
                <img src={filterOptionIcon} /> {BUTTON_TEXT.show}{' '}
                <img src={collapseDown} alt="Hide icon" />
              </>
            )}
          </Link>
        </div>
      );
    case 'copy':
      return (
        featurePermission && <Button
          {...props}
          variant={variant}
          className={className}
          onClick={onClick}
          sx={{ height: 40, ...sx }}
          startIcon={<ContentCopyIcon />}
        >
          <Typography variant="body1" fontWeight="bold" className = {typoClass ? typoClass : ''}>
            {children}
          </Typography>{''}
        </Button>
      );
    case 'add':
      return (
        featurePermission && <Button
          {...props}
          variant={variant}
          className={className}
          onClick={onClick}
          sx={{ height: 40, ...sx }}
          startIcon={<AddIcon />}
        >
          <Typography variant="body1" fontWeight="bold" className = {typoClass ? typoClass : ''}
          >
            {children}
          </Typography>{' '}
        </Button>
      );
    case 'print':
      return (
        featurePermission && <Button
          {...props}
          variant={variant}
          className={className}
          onClick={onClick}
          sx={{ height: 40, ...sx }}
          startIcon={<LocalPrintshopOutlinedIcon />}
        >
          <Typography variant="body1" fontWeight="bold">
            {children}
          </Typography>{' '}
        </Button>
      );
    case 'eye':
      return (
        featurePermission && <Button
          {...props}
          variant={variant}
          className={className}
          onClick={onClick}
          sx={{ height: 40, ...sx }}
          startIcon={<RemoveRedEyeOutlinedIcon />}
        >
          <Typography variant="body1" fontWeight="bold">
            {children}
          </Typography>{' '}
        </Button>
      );
    default:
      return null;
  }
};

export default CustomButton;
